import React from 'react';
import { Link } from 'react-router-dom';
import { Monitor, Smartphone, TrendingUp, Users, ArrowRight } from 'lucide-react';

const RelatedServices = ({ currentService }) => {
  const allServices = [
    {
      id: 'web',
      icon: <Monitor className="w-10 h-10" />,
      title: 'Webサイト制作',
      description: 'お店の魅力を伝える、やさしいデザインのホームページ',
      link: '/services/web'
    },
    {
      id: 'sns',
      icon: <Smartphone className="w-10 h-10" />,
      title: 'SNS運用サポート',
      description: 'InstagramやFacebookの運用をまるごとお任せ',
      link: '/services/sns'
    },
    {
      id: 'marketing',
      icon: <TrendingUp className="w-10 h-10" />,
      title: 'マーケティングサポート',
      description: 'Googleマップ最適化で地域のお客様に見つけてもらう',
      link: '/services/marketing'
    },
    {
      id: 'consulting',
      icon: <Users className="w-10 h-10" />,
      title: 'ビジネスコンサルティング',
      description: 'お店の経営をサポートする優しい相談役',
      link: '/services/consulting'
    }
  ];

  const relatedServices = allServices.filter(service => service.id !== currentService);

  return (
    <section className="section-spacing bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-4" style={{ color: '#2C2C2C' }}>
          その他のサービス
        </h2>
        <p className="text-center text-gray-600 mb-12">
          お店の状況に合わせて、組み合わせてのご利用も可能です
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {relatedServices.map((service, index) => (
            <Link
              key={index}
              to={service.link}
              className="bg-white rounded-2xl shadow-md p-6 hover-lift border border-gray-100"
            >
              <div className="mb-4" style={{ color: '#F7C9D3' }}>
                {service.icon}
              </div>
              <h3 className="text-xl font-semibold mb-3" style={{ color: '#2C2C2C' }}>
                {service.title}
              </h3>
              <p className="text-gray-600 mb-4 text-sm">
                {service.description}
              </p>
              <span className="inline-flex items-center text-[#F7C9D3] hover:text-[#2C2C2C] font-medium text-sm transition-colors">
                詳しく見る
                <ArrowRight className="ml-2 w-4 h-4" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RelatedServices;